export enum CIBPageName {
  CRD_BookingPage = 'crd-booking-page',
  CRD_CurrentProgress_TierProgress = 'crd-current-progress-tier-progress',
  CRD_CurrentProgress_SpendingBreakdown = 'crd-current-spending-breakdown',
  CRD_LandingPage = 'crd-dashboard',
  CRD_PointsActivity = 'crd-points-activity',
  CRD_Wallet = 'crd-wallet',
  RETAILER_CurrentProgress = 'retailer-current-progress',
  RETAILER_Dashboard = 'retailer-dashboard',
  RETAILER_PointsActivity = 'retailer-points-activity',
  RETAILER_ProgramOverview = 'retailer-program-overview',
  RETAILER_Wallet = 'retailer-wallet',
  RP_CurrentProgress = 'rp-current-progress',
  RP_CustomerRecord = 'rp-customer-record',
  RP_PointsActivity = 'rp-points-activity',
  RP_Wallet ='rp-wallet',
}
